import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import '../styles/navbar.css';
import { Link } from "react-router-dom";
import logo from '../image/favicon bl.png';

const NavBar = () => {

  const [expanded, setExpanded] = useState(false);
  const [hamActive, setHamActive] = useState(false); // Added missing state

  useEffect(() => {
    const nav = document.querySelector('.navigation-wrap');
    const toggler = document.querySelector('.navbar-toggler');

    const handleScroll = () => {
      if (document.documentElement.scrollTop > 20) {
        nav.classList.add('scroll-on');
      } else if (!toggler.classList.contains('collapsed')) {
        nav.classList.add('scroll-on');
      } else {
        nav.classList.remove('scroll-on');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll); // Cleanup
    };
  }, []);

  // 🔥 CLOSE MENU when clicking any nav link
  const closeMenu = () => {
    setExpanded(false);
    setHamActive(false); // Reset hamburger animation

    // force collapse hide
    const navCollapse = document.querySelector(".navbar-collapse");
    navCollapse?.classList.remove("show");
  };

  return (
    <>
      <header>
        <Navbar
          expand="lg"
          className="navigation-wrap"
          expanded={expanded}
        >
          <Container>
            <Navbar.Brand>
              <img src={logo} className="img-fluid" alt="logo" />
            </Navbar.Brand>

            <Navbar.Toggle
              aria-controls="navbarNav"
              aria-label="Toggle navigation"
              className="p-0 custom-toggler"
              onClick={() => {
                setExpanded(!expanded);      // Control collapse
                setHamActive(!hamActive);    // Animate hamburger
              }}
            >
              <div className={`hamburger ${hamActive ? "active" : ""}`} id="hamburger">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </Navbar.Toggle>

            <Navbar.Collapse id="navbarNav">
              <Nav className="ms-auto mb-2 mb-lg-0">
                <Nav.Item>
                  <Nav.Link as={Link} to="/" onClick={closeMenu}>Home</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link as={Link} to="/craftsmanship" onClick={closeMenu}>Craftsmanship</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link as={Link} to="/test" onClick={closeMenu}>Testimonial</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link as={Link} to="/about" onClick={closeMenu}>About Us</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link as={Link} to="/contact" onClick={closeMenu}>Contact Us</Nav.Link>
                </Nav.Item>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  );
}

export default NavBar;
